import { render, staticRenderFns } from "./GridMobile.vue?vue&type=template&id=06716cf8&"
import script from "./GridMobile.vue?vue&type=script&lang=js&"
export * from "./GridMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports